import React from 'react';

import { AlertComponent } from 'components/_basic/AlertComponent';
import { Loader } from 'components/_basic/Loader/Loader';

import DefaultPlaceholder from './Placeholder';
import { ILoadingDecoratorProps } from './types';

function LoadingDecorator<D>(props: ILoadingDecoratorProps<D>): React.ReactElement {
  if (props.loading) {
    return props.loadingComponent || <Loader className={props.loadingClassName} />;
  }

  if (props.error) {
    return <AlertComponent severity="error" message={props.error.message} />;
  }

  const { data, shouldRenderPlaceholder = () => false } = props;

  if (!data || shouldRenderPlaceholder(data)) {
    return props.placeholder !== undefined ? <>{props.placeholder}</> : <DefaultPlaceholder />;
  }

  return <>{props.children(data)}</>;
}

export default LoadingDecorator;
